module.exports = __webpack_public_path__ + "img/LOGOss.d7875b1b.jpg";